<div class="videobg">
  <div class="videobg-width">
    <div class="videobg-aspect">
      <div class="videobg-make-height">
        <video #videoEl playsinline crossorigin="anonymous" [poster]="posterUrl"></video>
      </div>
    </div>
  </div>
</div>
<app-rating-header
  [question]="question"
  [currentItem]="startAt"
  [count]="items.length">
</app-rating-header>
<app-media-play
  [shouldShowPlay]="showShowPlay"
  [underPlay]="underPlay"
  [duration]="duration"
  [currentTime]="currentTime"
  (played)="onPlay()">
</app-media-play>
<app-vote
  [showVote]="showVote"
  [currentItem]="startAt"
  [mediaType]="'video'"
  [count]="items.length"
  [underPlay]="underPlay"
  (makeVote)="onVote($event)"
  (makeSubmitVote)="onSubmitVote($event)">
</app-vote>
<app-media-control
  [duration]="duration"
  [currentTime]="currentTime"
  [progressValue]="progressValue"
  [underPlay]="underPlay"
  (paused)="onPause($event)"
  (played)="onPlay()">
</app-media-control>
